import type { AxiosError } from 'axios'
import type { CreateFlexGroup, FlexGroup } from 'BrokerTsLib/src/dtos'
import { useCustomToast } from 'brokertslib/src/hooks/useCustomToast'
import { useCreate } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { DashboardHeader, DashboardHeaderBackButton } from '@/containers/dashboard/DashboardHeader'
import { FlexGroupForm } from '@/containers/flex-group/FlexGroupForm'
import { PageWrapper } from '@/layouts/components/PageWrapper'

export const FlexGroupCreatePage = () => {
  const navigate = useNavigate()
  const { errorToast } = useCustomToast()

  const [flexGroup] = useState<FlexGroup>({
    valid: true,
    name: ''
  } as FlexGroup)

  const { mutateAsync: createAsync } = useCreate()

  const onSubmit = (data: CreateFlexGroup) =>
    createAsync(data)
      .then((response) => {
        navigate(`/flex-group/${response.id}`)
        return response
      })
      .catch(errorToast('Chyba při vytváření flexibilní skupiny')) as Promise<FlexGroup | AxiosError>

  return (
    <PageWrapper
      header={<DashboardHeader title='Vytvořit flexibilní skupinu'>
        <DashboardHeaderBackButton onClick={() => navigate('/flex-group/list')}>Zpět na seznam flexibilních skupin</DashboardHeaderBackButton>
      </DashboardHeader>}
      mainProps={{
        sx: {
          pt: { base: 0, sm: 8 },
          gap: 4,
          display: 'grid',
          w: { base: '100%', sm: 'md' },
          margin: '0 auto',
        }
      }}
    >
      {<FlexGroupForm flexGroup={flexGroup} isCreate onSubmit={onSubmit} />}
    </PageWrapper>
  )
}
